import React, { useRef, useState, useEffect } from 'react';
import { A11y, Pagination, Mousewheel, Lazy } from 'swiper';
import { Swiper as SwiperInstance, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import ProductImage from './ProductImage';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
const swiperModules = [A11y, Mousewheel, Lazy, Pagination];
const ProductTileCarousel = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    const { t } = useTranslation();
    const swiperRef = useRef();
    // const firstMove = useRef<boolean>(false);
    const [allowTransform, setAllowTransform] = useState(false);
    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '200px 0px',
    });
    const paginationWrapper = useRef();
    useEffect(() => {
        var _a;
        if (swiperRef.current) {
            (_a = swiperRef.current.el.querySelectorAll('img.swiper-lazy-loaded')) === null || _a === void 0 ? void 0 : _a.forEach((el) => el.classList.remove('swiper-lazy-loaded'));
            swiperRef.current.lazy.loadInSlide(swiperRef.current.activeIndex);
        }
    }, [props.productId]);
    const lazyLoadSwiperSlides = (swiper) => {
        var _a;
        if (!((_a = swiper === null || swiper === void 0 ? void 0 : swiper.slides) === null || _a === void 0 ? void 0 : _a.length))
            return;
        // Lazy Loading images starting from second slide (index number 1)
        for (let slideNum = 1; slideNum < swiper.slides.length; slideNum++) {
            swiper.lazy.loadInSlide(slideNum);
        }
    };
    // Check if nextImages has only one image (with _F suffix) - same logic as ProductImage
    const hasOnlyOneImage = (((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.nextImages) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.urls) === null || _c === void 0 ? void 0 : _c.length) == 1 && ((_g = (_f = (_e = (_d = props === null || props === void 0 ? void 0 : props.nextImages) === null || _d === void 0 ? void 0 : _d.next) === null || _e === void 0 ? void 0 : _e.urls) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.includes('_F'))) ||
        (((_k = (_j = (_h = props === null || props === void 0 ? void 0 : props.nextImages) === null || _h === void 0 ? void 0 : _h['plp-second']) === null || _j === void 0 ? void 0 : _j.urls) === null || _k === void 0 ? void 0 : _k.length) == 1 && ((_p = (_o = (_m = (_l = props === null || props === void 0 ? void 0 : props.nextImages) === null || _l === void 0 ? void 0 : _l['plp-second']) === null || _m === void 0 ? void 0 : _m.urls) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.includes('_F')));
    let imagesLength = 0;
    const createImageAttrs = (imageIndex) => {
        var _a, _b, _c;
        return {
            className: classNames('product-tile__image carousel-image', { 'swiper-lazy': imageIndex > 0 }),
            productId: props.productId,
            img: { alt: ((_a = props === null || props === void 0 ? void 0 : props.img) === null || _a === void 0 ? void 0 : _a.alt) || '', urls: ((_c = (_b = props === null || props === void 0 ? void 0 : props.img) === null || _b === void 0 ? void 0 : _b.urls) === null || _c === void 0 ? void 0 : _c.filter((url) => !(url.includes('_F.') || url.includes('_F1.')) && (url.includes('_X') || url.includes('_R')))) || [] },
            lazyDisabled: imageIndex === 0,
            animatedImage: true,
            imgQuality: props.imgQuality,
            ariaHidden: false,
            nextImages: props === null || props === void 0 ? void 0 : props.nextImages,
            tiletype: props.tiletype,
        };
    };
    return (React.createElement("div", { ref: ref, "aria-label": "images slider", "aria-roledescription": "carousel" },
        inView ? (React.createElement(React.Fragment, null,
            React.createElement(SwiperInstance, { onSwiper: (swiper) => {
                    swiperRef.current = swiper;
                    props.isSimplified && paginationWrapper.current.style.setProperty('--bullets-number', imagesLength.toString());
                }, onSliderFirstMove: (swiper) => {
                    // This is used to activate Swiper's lazyLoad on tiles touch
                    lazyLoadSwiperSlides(swiper);
                }, navigation: {
                    nextEl: `.tile-carousel__next--${props.productUuid}`,
                    prevEl: `.tile-carousel__prev--${props.productUuid}`,
                }, lazy: { loadOnTransitionStart: true }, a11y: {
                    enabled: true,
                    slideRole: 'group',
                    itemRoleDescriptionMessage: 'slide',
                    slideLabelMessage: '',
                    prevSlideMessage: t('label.previouspicture'),
                    nextSlideMessage: t('label.nextpicture'),
                }, className: classNames('product-tile--carousel', { hovering: props.isOver, 'allow-transform': allowTransform }), spaceBetween: 0, initialSlide: props.initialSlide || 0, speed: 500, threshold: 0, modules: swiperModules, pagination: !props.hideCarouselPagination && {
                    enabled: true,
                    clickable: true,
                    el: paginationWrapper.current,
                }, mousewheel: {
                    forceToAxis: true,
                    thresholdDelta: 20,
                    // sensitivity: 10,
                }, resistance: true, resistanceRatio: 0, 
                // loop
                // loopPreventsSlide={false}
                // OE-17878
                slidesPerView: 1, centeredSlides: true, 
                // End OE-17878
                onBeforeSlideChangeStart: (swiper) => {
                    window.isMobile() && setAllowTransform(true);
                    lazyLoadSwiperSlides(swiper);
                    setTimeout(() => {
                        swiper.pagination.bullets.map((bullet) => {
                            bullet.setAttribute('tabIndex', '-1');
                            bullet.setAttribute('aria-hidden', 'true');
                        });
                    }, 150);
                }, onSlideChange: (swiper) => {
                    props.isSimplified && paginationWrapper.current.style.setProperty('--bullets-active-offset', swiper.activeIndex * (100 / imagesLength) + '%');
                }, onAfterInit: (swiper) => {
                    if (!props.hideCarouselPagination) {
                        setTimeout(() => {
                            window.isMobile() && swiper.pagination.el.addEventListener('touchstart', () => setAllowTransform(true));
                            swiper.pagination.el.setAttribute('aria-hidden', 'true');
                            swiper.pagination.bullets.map((bullet) => {
                                bullet.setAttribute('tabIndex', '-1');
                                bullet.setAttribute('aria-hidden', 'true');
                            });
                        }, 150);
                    }
                }, onMouseEnter: () => {
                    // Mouse enter handler
                } },
                (!hasOnlyOneImage && ((_r = (_q = props === null || props === void 0 ? void 0 : props.nextImages) === null || _q === void 0 ? void 0 : _q.next) === null || _r === void 0 ? void 0 : _r.urls) && ((_u = (_t = (_s = props === null || props === void 0 ? void 0 : props.nextImages) === null || _s === void 0 ? void 0 : _s.next) === null || _t === void 0 ? void 0 : _t.urls) === null || _u === void 0 ? void 0 : _u.length) > 0) ? (() => {
                    var _a, _b, _c, _d, _e, _f;
                    // Determine which URLs array to use - must match ProductImage logic
                    let urls = [];
                    if (props.tiletype === 'PLP') {
                        urls = ((_b = (_a = props === null || props === void 0 ? void 0 : props.nextImages) === null || _a === void 0 ? void 0 : _a['plp-second']) === null || _b === void 0 ? void 0 : _b.urls) || ((_d = (_c = props === null || props === void 0 ? void 0 : props.nextImages) === null || _c === void 0 ? void 0 : _c.next) === null || _d === void 0 ? void 0 : _d.urls) || [];
                    }
                    else {
                        urls = ((_f = (_e = props === null || props === void 0 ? void 0 : props.nextImages) === null || _e === void 0 ? void 0 : _e.next) === null || _f === void 0 ? void 0 : _f.urls) || [];
                    }
                    return urls === null || urls === void 0 ? void 0 : urls.map((url, index) => {
                        // exclude F which is a duplicate of X
                        if (url && !(url.includes('_F.') || url.includes('_F1.'))) {
                            const imageIndex = imagesLength;
                            imagesLength++;
                            return (React.createElement(SwiperSlide, { key: index, "data-image-index": imageIndex },
                                React.createElement(ProductImage, Object.assign({ index: index, productUuid: props.productUuid, tiletype: props.tiletype }, createImageAttrs(imageIndex), { ariaHidden: true }))));
                        }
                        return null;
                    }).filter((item) => item !== null);
                })()
                    : ((_w = (_v = props.img) === null || _v === void 0 ? void 0 : _v.urls) === null || _w === void 0 ? void 0 : _w.length) > 0 && ((_y = (_x = props.img) === null || _x === void 0 ? void 0 : _x.urls) === null || _y === void 0 ? void 0 : _y.filter((url) => !(url.includes('_F.') || url.includes('_F1.')) && (url.includes('_X') || url.includes('_R'))).map((url, index) => {
                        // exclude F which is a duplicate of X
                        if (url) {
                            const imageIndex = imagesLength;
                            imagesLength++;
                            return (React.createElement(SwiperSlide, { key: index, "data-image-index": imageIndex },
                                React.createElement(ProductImage, Object.assign({ index: index }, createImageAttrs(imageIndex), { ariaHidden: true }))));
                        }
                    })),
                imagesLength > 1 && (React.createElement(React.Fragment, null,
                    React.createElement("button", { type: "button", className: `button button--tertiary-inverted button--arrow-left product-tile-carousel__button tile-carousel__prev--${props.productUuid}` }),
                    React.createElement("button", { type: "button", className: `button button--tertiary-inverted button--arrow-right product-tile-carousel__button tile-carousel__next--${props.productUuid}` })))))) : (React.createElement("div", { className: "swiper-slide-preload" },
            React.createElement(ProductImage, { productId: props.productId, img: props.img, className: classNames('product-tile__image carousel-image'), productUuid: props.productUuid, lazyLowRes: props.lazyLowRes, animatedImage: true, nextImages: props === null || props === void 0 ? void 0 : props.nextImages }))),
        props.isSimplified && React.createElement("div", { ref: paginationWrapper })));
};
export default ProductTileCarousel;
